import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import { Link as LinkRoute } from "react-router-dom";
import React from "react";

interface IProps {
  paths: {
    link: string;
    title: string;
    params?: string;
  }[];
}

const Breadcrumb: React.FC<IProps> = ({ paths }) => {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      <span>Pages</span>
      {paths.map((item, index) => {
        if (index === paths.length - 1) {
          return <span key={`${item.title}-${index}`}>{item.title}</span>;
        }
        return (
          <Link
            component={LinkRoute}
            color="inherit"
            to={{
              pathname: `${item.link}`,
              search: `${item.params ? item.params : ""}`,
            }}
            key={`${item.title}-${index}`}
          >
            {item.title}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
